var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BasePortalHost } from 'app/ui/core/portal';
import { UIPortalHostDirective } from 'app/ui/core/portal-directives';
var UISnackBarComponent = /** @class */ (function (_super) {
    __extends(UISnackBarComponent, _super);
    function UISnackBarComponent() {
        return _super.call(this) || this;
    }
    UISnackBarComponent.prototype.attachComponentPortal = function (portal) {
        return this.portalHost.attachComponentPortal(portal);
    };
    UISnackBarComponent.prototype.attachTemplatePortal = function (portal) {
        this.portalHost.attachTemplatePortal(portal);
    };
    return UISnackBarComponent;
}(BasePortalHost));
export { UISnackBarComponent };
